import React from 'react'
import { Divider, Typography } from 'antd'
import DS_OutwaredBin from '../../../../components/DispatchCentre/DS_OutwaredBin/DS_OutwaredBin'

const OutwaredBinPage = ({ userData }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Bin Status
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <DS_OutwaredBin />
        </>
    )
}

export default OutwaredBinPage